import React, { useState, useEffect } from 'react';
import NavigationMobileMenuSubItem from '../NavigationMobileMenuSubItem';
import NavigationMobileMenuSubItemThemes from '../NavigationMobileMenuSubItemThemes';

const NavigationMobileMenuitem = ({ item, title = 'Untitled', handleLinkClick, closeAllModals, isThemeMenu,
}) => {

  const href = item?.getIn(['link', 'url'], '');
  const itemTitle = item?.getIn(['link', 'title'], title);
  const [isOpen, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  const onLinkClick = () => {
    toggleOpen();
    handleLinkClick();
  };

  useEffect(() => {
    setOpen(false);
  }, [closeAllModals]);

  return (
    <li
      key={`menu--main--menu-item-${itemTitle}:${href}`}
      className="menu--main--menu-item"
    >
      {isThemeMenu && (
        <NavigationMobileMenuSubItemThemes
          closeAllModals={closeAllModals}
          handleLinkClick={onLinkClick}
        />
      )}
      {!isThemeMenu && (
        <NavigationMobileMenuSubItem
          closeAllModals={closeAllModals}
          key={itemTitle}
          subItem={item}
          handleLinkClick={onLinkClick}
        />
      )}

    </li>
  );
};

export default NavigationMobileMenuitem;
